export const MORTGAGE_PROVIDERS = [
  'AIB (NI)',
  'Accord Mortgages',
  'Aldermore',
  'BM Solutions',
  'Bank of Ireland',
  'Barclays',
  'Bath Investment & Building Society',
  'Bespoke by BOI',
  'Beverley',
  'Bluestone Mortgages',
  'Buckinghamshire Building Society',
  'Cambridge Building Society',
  'Chelsea Building Society',
  'Chorley & District Building Society',
  'Clydesdale Bank',
  'Coventry Building Society',
  'Cumberland',
  'Cynergy Bank',
  'Danske Bank',
  'Darlington Building Society',
  'Digital Mortgages',
  'Dudley Building Society',
  'Earl Shilton',
  'Ecology Building Society',
  'First Direct',
  'Fleet Mortgages',
  'Foundation Home Loans',
  'Furness Building Society',
  'Generation Home',
  'Godiva Mortgages',
  'HSBC',
  'Habito',
  'Halifax',
  'Hanley Economic Building Society',
  'Harpenden Building Society',
  'Hinckley & Rugby Building Society',
  'Hodge',
  'InterBay',
  'Ipswich Building Society',
  'Kensington',
  'Kent Reliance',
  'Keystone Property Finance',
  'Landbay',
  'Leeds Building Society',
  'Leek United',
  'Legal & General Home Finance',
  'LendInvest',
  'Livemore Capital',
  'Lloyds Bank',
  'Loughborough',
  'MBS Lending Ltd',
  'Mansfield',
  'Marsden',
  'Masthaven Bank',
  'Melton Mowbray',
  'Metro Bank',
  'Molo',
  'Monmouthshire Building Society',
  'NatWest',
  'Nationwide Building Society',
  'Newbury Building Society',
  'Newcastle Building Society',
  'Nottingham Building Society',
  'Paragon',
  'Penrith Building Society',
  'Pepper Money',
  'Platform',
  'Post Office Money',
  'Precise Mortgages',
  'Principality Building Society',
  'Progressive Building Society',
  'Reliance Bank',
  'Royal Bank of Scotland',
  'Saffron Building Society',
  'Santander',
  'Scottish Building Society',
  'Scottish Widows Bank',
  'Skipton Building Society',
  'Stafford Railway',
  'State Bank of India',
  'Swansea Building Society',
  'TSB',
  'Teachers Building Society',
  'The Family Building Society',
  'The Mortgage Lender',
  'The Mortgage Works',
  'Tipton & Coseley',
  'Together',
  'Ulster Bank',
  'United Trust Bank Ltd',
  'Vernon',
  'Vida Homeloans',
  'Virgin Money',
  'West Bromwich Building Society',
  'Yorkshire Bank',
  'Yorkshire Building Society',
  'Zephyr Homeloans',
]
